module.exports = __webpack_public_path__ + "img/鸡血藤.a827e024.jpg";